import React, { createContext, useContext, useState } from 'react';
import { INITIAL_VALUE } from './constants';
import { SINGLE_IDENTIFICATION_METHOD_PAGE } from 'constants/featureFlagging';
import withFeatureToggling from '../../../../../../hocs/withFeatureToggling/withFeatureToggling';
import withIdentifyMethodParser from '../../../../../../hocs/withIdentifyMethodParser';

export const IdentityViewContext = createContext(null);
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';

export const IdentityViewProvider = ({ flags, identificationByCountry, resetValidity, storage, children }) => {
    const [isVideoselfieWithBiometricsActive, setIsVideoselfieWithBiometricsActive] = useState(() => {
        const identificationData = storage.get('identification');

        return (
            identificationData?.isSelectedVideoselfieWithBiometrics ?? INITIAL_VALUE.isSelectedVideoselfieWithBiometrics
        );
    });

    const identificationMethods = identificationByCountry();
    const isSingleIdentificationMethodPageFFActive = flags.get(SINGLE_IDENTIFICATION_METHOD_PAGE);
    const isCarrouselActive = !isSingleIdentificationMethodPageFFActive || identificationMethods.length > 1;

    const setIsSelectedVideoselfieWithBiometrics = active => {
        const identificationData = storage.get('identification');
        setIsVideoselfieWithBiometricsActive(active);
        resetValidity('userProfile.agreeVideoCallClauseCheck');
        resetValidity('userProfile.videoCallClause');
        storage.set('identification', { ...identificationData, isSelectedVideoselfieWithBiometrics: active });
        window.scrollTo(0, 0);
    };

    return (
        <IdentityViewContext.Provider
            value={{
                isSelectedVideoselfieWithBiometrics: isVideoselfieWithBiometricsActive,
                setIsSelectedVideoselfieWithBiometrics,
                isCarrouselActive,
            }}
        >
            {children}
        </IdentityViewContext.Provider>
    );
};

export const useIdentityView = () => {
    const context = useContext(IdentityViewContext);
    if (!context) {
        throw new Error('useIdentityView must be used within an IdentityViewProvider');
    }

    return context;
};
export const withIdentityContext = (WrappedComponent, storage) => {
    const WithIdentityContext = ({ identificationByCountry, flags, resetValidity, ...restProps }) => {
        return (
            <IdentityViewProvider
                flags={flags}
                identificationByCountry={identificationByCountry}
                resetValidity={resetValidity}
                storage={storage}
            >
                <WrappedComponent identificationByCountry={identificationByCountry} {...restProps} />
            </IdentityViewProvider>
        );
    };
    WithIdentityContext.displayName = `WithIdentityContext(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;

    return withFeatureToggling(
        withIdentifyMethodParser(
            connect(null, {
                resetValidity: actions.resetValidity,
            })(WithIdentityContext)
        )
    );
};
